import UsersRepository from "./repos/usersRepository";
import CompanyRepository from "./repos/companyRepository";
import LogRepository from "./repos/logRepository";
import DeviceRepositry from "./repos/deviceRepository";
import DeviceFieldRepositry from "./repos/deviceFieldRepository";
import DeviceDataRepository from "./repos/deviceDataRepository";
import ConnectorRepository from "./repos/connectorRepository";

const repositories = {
  users: UsersRepository,
  companies: CompanyRepository,
  devices: DeviceRepositry,
  devicefields: DeviceFieldRepositry,
  devicedatas: DeviceDataRepository,
  connectors: ConnectorRepository,
  log: LogRepository
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
